import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import {
  CoachingDifficulty,
  kCoachingDifficulties,
} from '@euler/model/coaching';
import { memo, useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { levelName } from '../copy';

/** Four steps, the ones a case offers lit. */
export const LevelBar = memo(({ levels }: { levels: CoachingDifficulty[] }) => {
  const styles = useStyles();
  return (
    <View
      style={styles.bar}
      accessibilityLabel={`可选难度：${levels
        .map(level => levelName(level))
        .join('、')}`}
    >
      {kCoachingDifficulties.map(level => (
        <View
          key={level}
          style={[styles.step, levels.includes(level) && styles.lit]}
        />
      ))}
    </View>
  );
});

function useStyles() {
  const { rpx } = useResponsiveContext();
  return useMemo(
    () =>
      StyleSheet.create({
        bar: { flexDirection: 'row', gap: rpx(2) },
        step: {
          width: rpx(16),
          height: rpx(6),
          borderRadius: rpx(3),
          backgroundColor: aiColors.muted,
        },
        lit: { backgroundColor: aiColors.primary },
      }),
    [rpx],
  );
}
